export default __webpack_public_path__ + "static/media/pyn-launch-logo-img.d2092543.png";